import Text from "@/shared/typography/text";
import { ReactNode } from "react";

export function DetailField({
  label,
  children,
}: {
  label: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1">
      <Text type="caption" color="secondary">
        {label}
      </Text>
      <div className="text-sm">{children}</div>
    </div>
  );
}
